import { Smile, Battery, Zap, Star, Brain } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function useJournalMetrics() {
  const { t } = useTranslation();
  
  return [
    {
      id: 'mood',
      label: t('journal.metrics.mood'),
      icon: Smile,
      type: 'both'
    },
    {
      id: 'energy',
      label: t('journal.metrics.energy'),
      icon: Battery,
      type: 'morning'
    },
    {
      id: 'motivation',
      label: t('journal.metrics.motivation'),
      icon: Zap,
      type: 'morning'
    },
    {
      id: 'accomplishment',
      label: t('journal.metrics.accomplishment'),
      icon: Star,
      type: 'evening'
    },
    {
      id: 'reflection',
      label: t('journal.metrics.reflection'),
      icon: Brain,
      type: 'evening'
    }
  ];
}